var jQuery=$=require('jquery');
    window.jQuery=jQuery;
    require('bootpag');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
                country:'',
                url : this.baseApiPath,
                show_country:false,
                addCountry:'国家',
                addCity:'城市',
                countryname:'',
                editId:'',
                en:'',
                latlng:'',
                countryid:'',
                countrylist:{},
                citylist:{},
                cityid:'',
                show_city:false,
                cityname:'',
                city: '',
                hotelId: '',
                addname:'',
                adden:'',
                name: '',
                en: '',
                user:'',
                brand: '',
                type:0,
                newtype:0,
                typekey:0,
                star: 0,
                limit: 20,
                page: 1,
                editCountryName:'',
                total: 0,
                list: [],
                rows:0
            }
        },
        // compiled:function(){
        //     console.log('compiled')
        // },
        created:function(){
       
        },
        computed:{
        },
        ready:function(){
            //console.log('readyready')
            var that=this;
            this.search('',0);

            $('#callBackPager').bootpag({
               total: this.total,
                page:1,
                maxVisible: 10
                }).on("page", function(event, /* page number here */ num){
                    // console.log(1)
                that.search({page:num},1)
              });
            var jqPromise = $.post(this.url, {
                method: 'district_country',
                token: localStorage['token']
            });
            var realPromise = Promise.resolve(jqPromise),
            that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.countrylist = val.data;
            });
            this.$watch('countryid', function(val) {
                // this.search(val);
                if(typeof val !== "string"){
                    val=val[0]
                }
                 var promise = $.post(this.url, {
                method: 'district_city',
                token: localStorage['token'],
                country:val
            });
            var realPromise = Promise.resolve(promise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.citylist = val.data;
            });
            })
        },
        methods:{
            newAround:function(){
                 this.addCountry='国家'
                this.addCity='城市'
                this.addname=''
                this.adden=''
                this.newtype=''
                this.countryid=''
                this.cityid=''
                this.latlng=''
            },
            editAround:function(item){
                for (var i in this.countrylist) {
                    if (i==item.country) {
                        this.addCountry=this.countrylist[i].name
                    }
                }
            var that=this
            var promise = $.post(this.url, {
                method: 'district_city',
                token: localStorage['token'],
                country:item.country
            });
            var realPromise = Promise.resolve(promise),
                that = this;
            realPromise.then(function(val) {
                var val = JSON.parse(val)
                that.citylist = val.data;
            })
            .then(function(val){
                for (var j in that.citylist) {
                    if (j==item.city) {
                        that.addCity=that.citylist[j].name
                    }
                }
            })
                this.editId=item.id
                this.addname=item.name
                this.adden=item.en
                this.newtype=item.type
                this.countryid=item.country
                this.cityid=item.city
                this.latlng=[item.lat,item.lng].join(',')
            },
            delAround:function(id){
                  var data={
                    method:'around_delete',
                    id:id,
                    token:localStorage['token'],
                }
                  this.$http.post(this.url,data,{emulateJSON:true})
                    .then(function(value){
                    var value=JSON.parse(value)
                    if (value.code==0) {
                        alert('删除成功')
                    }
                    return value
                 })
                .then(function(value){
                    this.search('',0);
                })
            },
            updateAround:function(id){
                var data={
                    method:'around_update',
                    id:this.editId,
                    name:this.addname,
                    en:this.adden,
                    token:localStorage['token'],
                    type:this.newtype,
                    country:this.countryid,
                    city:this.cityid,
                    lat:this.latlng.split(',')[1],
                    lng:this.latlng.split(',')[0]
                }
                this.$http.post(this.url,data,{emulateJSON:true})
                    .then(function(value){
                        console.log(value)
                        if (value.data.code==0) {
                             alert('编辑成功')
                              this.search('',0);
                        }
                    
                    return value
                 });
            },
            addAround:function(){
                var data={
                    method:'around_create',
                    name:this.addname,
                    en:this.adden,
                    token:localStorage['token'],
                    type:this.newtype,
                    country:this.countryid,
                    city:this.cityid,
                    lat:this.latlng.split(',')[1],
                    lng:this.latlng.split(',')[0]
                }
                this.$http.post(this.url,data,{emulateJSON:true})
                    .then(function(value){
                        console.log(value)
                        if (value.data.code==0) {
                                alert('添加成功')
                              this.search('',0);
                        }
                    
                    return value
                 });
            },
            choicecountry:function(item){
                this.addCountry=item.name;
                this.countryid=item.id
                this.show_country=false
                this.city='';
                this.cityname='';
            },
              choicecity:function(item){
                this.addCity=item.name;
                this.cityid=item.id;
                this.show_city=false
                this.district='';
                this.districtname='';
            },
            showCountry:function(){
                this.show_city=false;
                this.show_country==true?this.show_country=false:this.show_country=true;
                
            },
            showCity:function(){
                this.show_country=false;
                this.show_city==true?this.show_city=false:this.show_city=true;
            },
           search:function(val,rebuild){
                var url = this.baseApiPath;
                allHotelData = {
                    method: 'around_search',
                    token: localStorage.token,
                    // keyword: val&&val.keyword||this.keyword || '',
                    limit: val&&val.limit||this.limit || '',
                    page: val&&val.page||this.page|| 1
                }
                var jqPromise = $.post(url, allHotelData);
                var realPromise = Promise.resolve(jqPromise);
                var that = this,rebuild=rebuild;
                realPromise.then(function(res) {
                    var res = JSON.parse(res)
                    if (res.code == 0) {
                        that.list = res.data['list'];
                        that.rows = res.data.page.rows;
                        that.total = res.data.page.total
                    } else {
                        alert(res['message'])
                    }
                    return res;
                })
                .then(function(res) {
                    if(!rebuild){
                          $('#callBackPager').bootpag({
                            total: that.total,
                            page:1,
                            maxVisible: 10
                        }).on("page", function(event, num){
                             that.search({page:num},1)
                        });
                    }
                    return res;
                })
            }
        },
        route:{
            activate:function(transtition){
                transtition.next()
            },
            data:function(transtition){
                this.search('',0);

                 this.$dispatch('pageinfo','');
                transtition.next();
            }
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/aroundList.vue
// module id = 83
// module chunks = 0